(function ($) {
	// Add event listeners to buttons that switches maps/filters
	var switchMaps = function () {
		// Collect the elements
		const salesMap = document.querySelector('.contact-page__map-container--sales');
		const serviceMap = document.querySelector('.contact-page__map-container--service');
		const salesButton = document.querySelector('.contact-page__map__filter-button--sales');
		const serviceButton = document.querySelector('.contact-page__map__filter-button--service');
		const infoWindow = document.querySelector('#infowindow');
		const srSpeak = document.querySelector('#sr-speak');

		salesButton.addEventListener('click', (event) => {
			event.target.classList.add('active');
			event.target.ariaSelected = 'true';
			serviceButton.ariaSelected = 'false';
			serviceButton.classList.remove('active');
			salesMap.classList.add('show');
			salesMap.classList.remove('hide');
			serviceMap.classList.add('hide');
			serviceMap.classList.remove('show');
			infoWindow.classList.remove('hidden');

			srSpeak.innerText = 'Sales rep map activated.';
		});

		serviceButton.addEventListener('click', (event) => {
			event.target.classList.add('active');
			event.target.ariaSelected = 'true';
			salesButton.ariaSelected = 'false';
			salesButton.classList.remove('active');
			serviceMap.classList.add('show');
			serviceMap.classList.remove('hide');
			salesMap.classList.add('hide');
			salesMap.classList.remove('show');
			infoWindow.classList.add('hidden');

			srSpeak.innerText = 'Service center map and filters activated.';
		});
	};

	$(window).load(function () {
		switchMaps();
	});
})(jQuery);
